var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3846 1.5C9.05318 1.5 7.96154 2.59165 7.96154 3.92308V6.34615H3.92308C2.59165 6.34615 1.5 7.4378 1.5 8.76923V20.0769C1.5 21.4084 2.59165 22.5 3.92308 22.5H13.6154C14.9468 22.5 16.0385 21.4084 16.0385 20.0769V17.6538H20.0769C21.4084 17.6538 22.5 16.5622 22.5 15.2308V6.81941L17.1806 1.5H10.3846ZM10.3846 3.11538H16.0385V7.96154H20.8846V15.2308C20.8846 15.6851 20.5312 16.0385 20.0769 16.0385H16.0385V11.6656L10.719 6.34615H9.57692V3.92308C9.57692 3.46875 9.93029 3.11538 10.3846 3.11538ZM17.6538 4.25751L19.7425 6.34615H17.6538V4.25751ZM3.92308 7.96154H9.57692V12.8077H14.4231V20.0769C14.4231 20.5312 14.0697 20.8846 13.6154 20.8846H3.92308C3.46875 20.8846 3.11538 20.5312 3.11538 20.0769V8.76923C3.11538 8.3149 3.46875 7.96154 3.92308 7.96154ZM11.1923 9.10366L13.2809 11.1923H11.1923V9.10366Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.1490def1085fe47c87f39dd851b6e155.svg";
export { ForwardRef as ReactComponent };